import styled from 'styled-components'

import { ButtonSolid } from 'components/Buttons'

export const ContinueButton = styled(ButtonSolid)`
	font-size: 19px;
	min-width: 239px;
`
